import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "-1 0 6 11",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.889 0.789 C 0.565 0.834,0.292 1.077,0.209 1.395 C 0.179 1.508,0.179 1.694,0.209 1.805 C 0.238 1.914,0.299 2.031,0.369 2.115 C 0.401 2.154,1.094 2.918,1.909 3.814 C 2.723 4.710,3.390 5.446,3.390 5.450 C 3.390 5.454,2.706 6.209,1.870 7.129 C 1.035 8.048,0.338 8.819,0.322 8.843 C 0.123 9.133,0.141 9.542,0.366 9.814 C 0.476 9.947,0.632 10.048,0.796 10.091 C 0.906 10.120,1.094 10.120,1.202 10.091 C 1.305 10.064,1.411 10.014,1.488 9.955 C 1.531 9.923,2.140 9.260,3.332 7.948 C 4.312 6.871,5.133 5.964,5.157 5.933 C 5.261 5.799,5.312 5.641,5.312 5.450 C 5.312 5.355,5.307 5.306,5.291 5.246 C 5.267 5.156,5.216 5.045,5.168 4.980 C 5.150 4.955,4.327 4.046,3.339 2.960 C 2.154 1.656,1.523 0.970,1.484 0.941 C 1.325 0.823,1.085 0.762,0.889 0.789 ",
		stroke: "none",
		fillRule: "evenodd"
	})
});
export default SvgCaretRight;
